import { ViewModel } from './_vm'

import FormStore from './store/_form-store'
import UiStore from '../store/_ui-store'
import SelectTemplate from './_selectTemplate'

/**
 * GadgetButton // セレクトのjs
 *
 * @returns {undefined}
 */
export class GadgetButton extends ViewModel {
  constructor($element, controller) {
    super(GadgetButton.name(), $element, controller)
    this.formName = this.$element.attr('name')
    this.disableClass = 'disable'

    // イベントの登録
    // this.$element.on('change', () => this.select())
    this.on(`GadgetButton`, () => this.render())
    this.$element
      .parent()
      .find('.plus_count[name=' + this.formName + ']')
      .on('click', () => this.plusClick())
    this.$element
      .parent()
      .find('.minus_count[name=' + this.formName + ']')
      .on('click', () => this.minusClick())
    // this.on(`GadgetButton:Room`, () => this.roomRender())
    // this.on(`GadgetButton:${this.formName}`, () => this.render())
    // this.click(``, () => this.click())
    // this.option()

    // 様子見
    // this.render()
    // this.roomRender()
  }

  static name() {
    return 'GadgetButton'
  }

  static className() {
    return '.js-kaigai-gadget-button'
  }

  plusClick() {
    console.log('plusClick')
    console.log('element', this.$element)
    if (
      $(this.$element)
        .parent()
        .find('.plus_count.disable[name=' + this.formName + ']').length > 0
    )
      return
    this.target = this.formName.replace('Plus', '').replace('Minus', '')
    console.log('target', this.target)
    const target = this.$element.parent().find('#' + this.target)
    const targetNum = target.data(this.target)
    const targetNewNum = targetNum + 1
    target.data(this.target, targetNewNum)
    target.html(targetNewNum)
    FormStore.updateData(this.target, targetNewNum)
    UiStore.updateData(this.target, targetNewNum)
    const clickable = this.countCheck()
    this.buttonDisable()
    this.trigger('GadgetPeopleButton:countCheck')
    if (this.target !== 'roomNum') return
    this.trigger('tourDetailRoomAllocation')
    console.log('target更新済み', target.data(this.target))
  }

  minusClick() {
    if (
      $(this.$element)
        .parent()
        .find('.minus_count.disable[name=' + this.formName + ']').length > 0
    )
      return
    // const roomNum = FormStore.getData('roomNum', 0)
    // if (roomNum < 5) {
    //   for (let i = roomNum; i <= 5; i++) {
    //     UiStore.updateData(`room${i}age20r`, 0)
    //     UiStore.updateData(`room${i}age6r`, 0)
    //     UiStore.updateData(`room${i}age0r`, 0)

    //     $(`.room${i}age20r`).data(`room${i}age20r`, 0)
    //     $(`.room${i}age20r`).html(0)
    //     $(`.room${i}age6r`).data(`room${i}age6r`, 0)
    //     $(`.room${i}age6r`).html(0)
    //     $(`.room${i}age0r`).data(`room${i}age0r`, 0)
    //     $(`.room${i}age0r`).html(0)
    //     console.log('deleteRoomNum', i)
    //     console.log('deleteRoomNum:age20r', $(`.room${i}age20r`))
    //     console.log('deleteRoomNum:age6r', $(`.room${i}age6r`))
    //     console.log('deleteRoomNum:age0r', $(`.room${i}age0r`))
    //   }
    // }

    this.target = this.formName.replace('Plus', '').replace('Minus', '')
    const target = this.$element.parent().find('#' + this.target)
    const targetNum = target.data(this.target)
    const targetNewNum = targetNum - 1
    target.data(this.target, targetNewNum)
    target.html(targetNewNum)
    FormStore.updateData(this.target, targetNewNum)
    UiStore.updateData(this.target, targetNewNum)
    const clickable = this.countCheck()
    this.buttonDisable()
    this.trigger('GadgetPeopleButton:countCheck')
    // if (this.target !== 'roomNum') {
    //   return
    // }
    this.trigger('tourDetailRoomAllocation')
  }

  countCheck() {
    const roomNum = FormStore.getData('roomNum', 0)
    let adult = 0
    let child = 0
    let inf = 0
    let totalNum = 0
    const people = UiStore.getData(`room0people`, 0)
    for (let i = 1; i <= roomNum; i++) {
      adult = UiStore.getData(`room${i}age20r`, 0)
      child = UiStore.getData(`room${i}age6r`, 0)
      inf = UiStore.getData(`room${i}age0r`, 0)
      totalNum += adult + child + inf
      this.roomDisable(`room${i}age20r`)
    }
    // for (let j = i; j <= roomNum; j++) {
    //   UiStore.updateData(`room${j}age20r`, 0)
    //   UiStore.updateData(`room${j}age6r`, 0)
    //   UiStore.updateData(`room${j}age0r`, 0)
    // }
    // totalが作業中
    if (totalNum >= 9) {
      UiStore.updateData(`plusDisable`, true)
    } else {
      UiStore.updateData(`plusDisable`, false)
    }
    if (totalNum <= 1) {
      UiStore.updateData(`minusDisable`, true)
    } else {
      UiStore.updateData(`minusDisable`, false)
    }
    if (roomNum >= 5) {
      UiStore.updateData(`roomPlusDisable`, true)
    } else {
      UiStore.updateData(`roomPlusDisable`, false)
    }
    if (roomNum <= 1) {
      UiStore.updateData(`roomMinusDisable`, true)
    } else {
      UiStore.updateData(`roomMinusDisable`, false)
    }
    UiStore.updateData(`totalNum`, totalNum)
    console.log('totalNum', UiStore.getData(`totalNum`, 0))
    console.log('roomNum', roomNum)
    return (totalNum > 1 && totalNum < 9 && inf <= adult) || adult >= 1
  }

  buttonDisable() {
    if (UiStore.getData(`roomPlusDisable`, false) === true) {
      $('.plus_count').addClass(this.disableClass)
    } else {
      $('.plus_count').removeClass(this.disableClass)
    }
    if (UiStore.getData(`roomMinusDisable`, false) === true) {
      $('.minus_count').addClass(this.disableClass)
    } else {
      $('.minus_count').removeClass(this.disableClass)
    }
    console.log('roomPlusDisable', UiStore.getData(`roomPlusDisable`))
    console.log('roomMinusDisable', UiStore.getData(`roomMinusDisable`))
  }

  roomDisable(room) {
    console.log('roomDisable', room)

    // if (UiStore.getData(`roomPlusDisable`, false) === true) {
    //   $('.plus_count').addClass(this.disableClass)
    // } else {
    //   $('.plus_count').removeClass(this.disableClass)
    // }
    // if (UiStore.getData(`roomMinusDisable`, false) === true) {
    //   $('.minus_count').addClass(this.disableClass)
    // } else {
    //   $('.minus_count').removeClass(this.disableClass)
    // }
    // console.log('roomPlusDisable', UiStore.getData(`roomPlusDisable`))
    // console.log('roomMinusDisable', UiStore.getData(`roomMinusDisable`))
  }

  //   peoplePlusClick() {
  //     console.log('peoplePlusClick')
  //     // this.target = this.formName.replace('Plus', '').replace('Minus', '')
  //     // console.log('target', this.target)
  //     // const target = this.$element.parent().find('#' + this.target)
  //     // const targetNum = target.data(this.target)
  //     // const targetNewNum = targetNum + 1
  //     // target.data(this.target, targetNewNum)
  //     // target.html(targetNewNum)
  //     // FormStore.updateData('roomNum', targetNewNum)
  //     // console.log('target更新済み', target.data(this.target))
  //   }

  //   peopleMinusClick() {
  //     console.log('peopleMinusClick')
  //     // this.target = this.formName.replace('Plus', '').replace('Minus', '')
  //     // const target = this.$element.parent().find('#' + this.target)
  //     // const targetNum = target.data(this.target)
  //     // const targetNewNum = targetNum - 1
  //     // FormStore.updateData('roomNum', targetNewNum)
  //     // this.trigger('tourDetailRoomAllocation')
  //     // target.data(this.target, targetNewNum)
  //     // target.html(targetNewNum)
  //   }

  render() {
    console.log(999999999)
    console.log(this.formName)
    // this.option()
    // const val = String(FormStore.getData(this.formName))
    // this.$element.val(val)
  }

  roomRender() {
    console.log(11111111111)
    console.log(this.formName)
    // this.$element
    //   .parent()
    //   .find('.plus_count_room[name=' + this.formName + ']')
    //   .on('click', () => this.peoplePlusClick())
    // this.$element
    //   .parent()
    //   .find('.minus_count_room[name=' + this.formName + ']')
    //   .on('click', () => this.peopleMinusClick())
  }

  /**
   * option // データが取れれば選択肢を追加する
   */
  option() {
    const list = this.list()
    if (list === '') return
    this.$element.empty()
    this.$element.append(list)
  }

  /**
   * list // 選択肢のhtmlを取得
   */
  list() {
    const current = FormStore.getData(this.formName)
    const data = FormStore.selectList(this.formName)
    return SelectTemplate.selectList(data, current)
  }

  select() {
    const item = $('option:selected', this.$element).val() ? $('option:selected', this.$element).val() : null

    FormStore.GadgetButton(this.formName, item)
    this.trigger(`GadgetButton:${this.formName}`)
    FormStore.validation(this.formName)
    this.trigger('Form:errors')
  }
}
